import React from 'react';
import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';



const ChatMessage = ({ role, content, timestamp }) => {
  const isUser = role === 'user';

  const components = {
    code({ node, inline, className, children, ...props }) {
      const match = /language-(\w+)/.exec(className || '');
      return !inline && match ? (
        <SyntaxHighlighter
          language={match[1]}
          style={vscDarkPlus}
          showLineNumbers
        >
          {String(children).replace(/\n$/, '')}
        </SyntaxHighlighter>
      ) : (
        <code className={className} {...props}>{children}</code>
      );
    }
  };

  return (
    <motion.div
      className={`message ${role}`}
      initial={{ opacity: 0, translateY: 10 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
    >
      <div className="message-content">
        <div className="message-header">
          <div className="message-icon">
            {isUser ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            ) : (
              <>4Q</>
            )}
          </div>

          <div className="message-header-text">
            <span>{isUser ? 'Você' : 'Java Dev Assistant'}</span>
            {timestamp && (
              <span className="message-timestamp">{timestamp}</span>
            )}
          </div>
        </div>

        <div className="message-inner">
          {isUser ? (
            <p>{content}</p>
          ) : (
            <ReactMarkdown components={components}>
              {content}
            </ReactMarkdown>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ChatMessage;
